import { jsx as _jsx } from "react/jsx-runtime";
import { TextFontWeights, TextLink } from "@cinch-labs/design-system";
const FooterLink = ({ href , label  })=>/*#__PURE__*/ _jsx(TextLink, {
        href: href,
        isOnlyWhite: true,
        hasNoLine: false,
        textProps: {
            fontWeight: TextFontWeights.semibold,
            fontSize: "s"
        },
        children: label
    });
export default FooterLink;
